<script lang="ts">
	import AbleyButton from './AbleyButton.svelte';
	import IconX from '#lib/assets/x-mark.svg?raw';

	interface Props {
		onclick: () => void;
		/** Name what it closes ("Close dialog", "Close filters"…). */
		'aria-label': string;
		disabled?: boolean;
		/** Native hover tooltip, e.g. why it's disabled. */
		title?: string;
	}

	const { onclick, 'aria-label': ariaLabel, disabled = false, title }: Props = $props();
</script>

<AbleyButton variant="text" size="sm" {onclick} aria-label={ariaLabel} {disabled} {title}>
	{@html IconX}
</AbleyButton>
